import { Separator } from "@base-ui/react/separator";
import { Progress } from "@base-ui/react/progress";
import { DropZone } from "./components/DropZone";
import { ClipList } from "./components/ClipList";
import { BoneMeter } from "./components/BoneMeter";
import { useTransferStore } from "./store/transferStore";

export function App() {
  const status = useTransferStore((s) => s.status);
  const busy = useTransferStore((s) => s.busy);
  const ready = useTransferStore((s) => s.ready());
  const runTransfer = useTransferStore((s) => s.runTransfer);

  return (
    <div className="app">
      <header>
        <h1>Animation Transfer</h1>
        <p className="tag">Mixamo · Ready Player Me · same-family rigs · glb → glb</p>
      </header>

      <DropZone slot="source" label="From — has the animations" prompt="Drop the animated GLB" />
      <ClipList slot="source" title="Clips to transfer" />

      <Separator className="flow" orientation="horizontal" aria-hidden />
      <div className="arrow" aria-hidden>
        ↓
      </div>

      <DropZone slot="target" label="To — receives the animations" prompt="Drop the target GLB" />
      <ClipList slot="target" title="Already on target — uncheck to remove" />

      <BoneMeter />

      <button className="go" disabled={!ready || busy} onClick={() => void runTransfer()}>
        {busy ? "Baking…" : "Transfer & download"}
      </button>

      {busy && (
        // Indeterminate progress while three.js bakes and exports the GLB.
        <Progress.Root className="progress" value={null}>
          <Progress.Track className="progress-track">
            <Progress.Indicator className="progress-indicator" />
          </Progress.Track>
        </Progress.Root>
      )}

      <div className={`status ${status.kind}`} role="status" aria-live="polite">
        {status.text}
      </div>
    </div>
  );
}
